export default __webpack_public_path__ + "img/stage5.5377564b.jpg";